import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { isNumeric } from "@coworker/app/src/helpers/utils";
import { reportMessageToSentry } from "@coworker/app/src/hooks/useConfigureSentry";
import { httpClient } from "@coworker/http-client";
import { isEmpty } from "@coworker/apprestructured/src/shared/helpers/string.helper";
import { formatProductIdWithDots } from "@coworker/reusable/formatters/product.formatter";

export async function fetchItemInfoAndPriceSR(
  itemNo: string
): Promise<Item | null> {
  if (!isNumeric(itemNo)) {
    reportMessageToSentry(
      `Getting item-info-price-sr called with a non-numeric itemNo: ${itemNo}`,
      {
        itemNo: itemNo,
      },
      "info"
    );
    return null;
  }
  const itemInfo = await httpClient.tasks.get<Item>(
    `/items/item-info-price-sr?itemNo=${itemNo}`
  );
  return itemInfo && !isEmpty(itemInfo)
    ? ({
        ...itemInfo,
        noFormatted: formatProductIdWithDots(itemInfo?.no),
      } as Item)
    : null;
}
